import React from 'react';
import './Metrics.scss';
import Menu from '../../components/Menu/Menu';

export default function Metrics() {
    return (
        <div id='metrics'>
            <div className='centered-container'>
                <Menu title="Metrics" options={[
                    { name: 'Pitis', path: '/metrics/pitis' },
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
}